import { DispatchedAction, Action, DispatchedAsyncAction } from "../../../types/actions";
import { LoadActivityLog, LoadActivityLogOptions } from "connection/activity-log";
import { IReturnableActivity } from "types/working-model";

export const FETCH_ACTIVITY_LOG = "FETCH_ACTIVITY_LOG";
type FetchActivityLogAction = DispatchedAsyncAction<typeof FETCH_ACTIVITY_LOG, { next: number | undefined; activities: IReturnableActivity[]; }>;
export function fetchActivityLog(
	channel: number,
	projectUuid: string,
	opts?: LoadActivityLogOptions
): FetchActivityLogAction {
	return {
		type: FETCH_ACTIVITY_LOG,
		promise: LoadActivityLog(channel, projectUuid, { ...(opts || {}), published: true })
	};
}

export const SET_SHOW_ACTIVITY_LOG_MODAL = "SET_SHOW_ACTIVITY_LOG_MODAL";
type SetShowActivityLogModalAction = DispatchedAction<typeof SET_SHOW_ACTIVITY_LOG_MODAL, boolean>;
export function setShowActivityLogModal(show: boolean): SetShowActivityLogModalAction {
	return {
		type: SET_SHOW_ACTIVITY_LOG_MODAL,
		payload: show
	};
}

export const SET_MORE_ACTIVITIES_AVAILABLE = "SET_MORE_ACTIVITIES_AVAILABLE";
type SetMoreActivitiesAvailableAction = DispatchedAction<typeof SET_MORE_ACTIVITIES_AVAILABLE, undefined>;
export function setMoreActivitiesAvailable(): SetMoreActivitiesAvailableAction {
	return {
		type: SET_MORE_ACTIVITIES_AVAILABLE,
		payload: undefined
	};
}

export const RESET_ACTIVITY_LOG = "RESET_ACTIVITY_LOG";
type ResetActivityLogAction = DispatchedAction<typeof RESET_ACTIVITY_LOG, undefined>;
export function resetActivityLog(): ResetActivityLogAction {
	return {
		type: RESET_ACTIVITY_LOG,
		payload: undefined
	};
}